import { Button, Card, Input } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";

import { useAppDispatch } from "../../../app/app.store";
import {
  useRequestOtpMutation,
  useVerifyOtpMutation,
} from "../../../app/features/auth/auth.api";
import { verifyUser } from "../../../app/features/auth/auth.slice";
import { errorToast } from "../../../utils/error.utils";
import Logo from "/images/logo.svg";

export default function Otp() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");

  const handleChange = (value: string) => {
    setOtp(value);
  };

  // State for timer
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds
  const [canResend, setCanResend] = useState(false);

  const location = useLocation();
  const dispatch = useAppDispatch();
  const [verifyOtp, { isLoading: isVerifying }] = useVerifyOtpMutation();
  const [requestOtp, { isLoading: isResending }] = useRequestOtpMutation();

  // const phone = location.state?.phone;
  const email = location.state?.email;

  // Timer logic
  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timerId);
    } else {
      setCanResend(true);
    }
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const handleSubmit = async () => {
    // TODO: phone
    if (!email || !otp) {
      console.error("Phone or OTP missing");
      return;
    }
    try {
      const res = await verifyOtp({ email, otp }).unwrap();
      if (res.accessToken) {
        dispatch(
          verifyUser({
            accessToken: res.accessToken,
            refreshToken: res.refreshToken,
          }),
        );
        navigate("/admin/dashboard");
      }
    } catch (error) {
      errorToast(error, "Failed to verify OTP ");
    }
  };

  const handleResendOtp = async () => {
    // TODO: phone
    if (!email) return;
    try {
      await requestOtp({ email }).unwrap();
      setTimeLeft(120);
      setCanResend(false);
    } catch (error) {
      errorToast(error, "Failed to send OTP");
    }
  };

  return (
    <div className="flex h-screen flex-col md:flex-row">
      {/* Right side - Login card */}
      <div className="w-full  relative bg-[#E9F2F2] flex items-center justify-center h-screen md:h-auto">
        {/* Centered Card */}
        <Card className="!max-w-96 shadow-lg sm:w-11/12" bordered={false}>
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src={Logo} alt="Logo" className="h-14 w-auto" />
          </div>

          <div className="text-theme-zinc-700 text-xl font-semibold mb-4">
            OTP Verification
          </div>

          <div className="justify-start text-slate-600 text-sm font-normal mb-6">
            OTP Verification for {email} email address
          </div>

          {/* Ant Design OTP Input */}
          <div className="mb-6">
            <Input.OTP
              value={otp}
              onChange={handleChange}
              length={6}
              autoFocus
              size="large"
              className="!gap-2 !justify-center"
            />
          </div>

          <div className="flex justify-between items-center mb-6">
            <Button
              type="link"
              disabled={!canResend || isResending}
              onClick={handleResendOtp}
              className="p-0 text-blue-600 font-normal"
            >
              {isResending ? "Sending..." : "Resend OTP"}
            </Button>
            {!canResend && (
              <span className="text-slate-500">
                {formatTime(timeLeft)} left
              </span>
            )}
          </div>

          <Button
            type="primary"
            onClick={handleSubmit}
            loading={isVerifying}
            block
            size="large"
          >
            Login
          </Button>
        </Card>
      </div>
    </div>
  );
}
